"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCar = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconCar = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "55",
    height: "37",
    viewBox: "0 0 55 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M15.6464 31.5341C13.9249 31.5341 12.5234 30.1326 12.5234 28.4111C12.5234 26.6896 13.9249 25.2881 15.6464 25.2881C17.3679 25.2881 18.7694 26.6896 18.7694 28.4111C18.7694 30.1326 17.3679 31.5341 15.6464 31.5341ZM15.6464 27.2278C14.9942 27.2278 14.4632 27.7588 14.4632 28.411C14.4632 29.0633 14.9942 29.5943 15.6464 29.5943C16.2987 29.5943 16.8296 29.0633 16.8296 28.411C16.8296 27.7588 16.2986 27.2278 15.6464 27.2278Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M41.5449 31.5341C39.8233 31.5341 38.4219 30.1326 38.4219 28.4111C38.4219 26.6896 39.8233 25.2881 41.5449 25.2881C43.2664 25.2881 44.6678 26.6896 44.6678 28.4111C44.6678 30.1326 43.2664 31.5341 41.5449 31.5341ZM41.5449 27.2278C40.8926 27.2278 40.3616 27.7588 40.3616 28.411C40.3616 29.0633 40.8926 29.5943 41.5449 29.5943C42.1971 29.5943 42.7281 29.0633 42.7281 28.411C42.7281 27.7588 42.1971 27.2278 41.5449 27.2278Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M53.4113 30.2535H48.2297C47.6938 30.2535 47.2598 29.8195 47.2598 29.2837C47.2598 28.7478 47.6938 28.3138 48.2297 28.3138H52.4414V16.6342L48.0357 13.7561C47.9193 13.681 47.8199 13.5791 47.7448 13.4603L40.5239 1.96701L15.0742 1.94519L9.64047 13.0841C9.56773 13.2344 9.45619 13.3653 9.31556 13.4599L1.94447 18.4936V28.3134H9.00519C9.54105 28.3134 9.97507 28.7475 9.97507 29.2833C9.97507 29.8192 9.54105 30.2532 9.00519 30.2532H0.974275C0.438417 30.2532 0.00439453 29.8192 0.00439453 29.2833V18.0737C0.00439453 17.7536 0.162002 17.3608 0.426294 17.1814L8.00595 11.9998L13.5925 0.54556C13.7549 0.210953 14.0944 0 14.4629 0L41.0597 0.0290964C41.3943 0.0290964 41.7022 0.201247 41.8792 0.482515L49.2745 12.2471L53.942 15.2974C54.216 15.4768 54.3809 15.7823 54.3809 16.1097V29.2833C54.3809 29.8191 53.9469 30.2532 53.411 30.2532L53.4113 30.2535Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M34.6517 30.2535H22.5817C22.0458 30.2535 21.6118 29.8195 21.6118 29.2837C21.6118 28.7478 22.0458 28.3138 22.5817 28.3138H34.6517C35.1875 28.3138 35.6215 28.7478 35.6215 29.2837C35.6215 29.8195 35.1875 30.2535 34.6517 30.2535Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M26.9095 15.5989H26.8901H13.4328C12.8969 15.5989 12.4629 15.1649 12.4629 14.629V11.7848C12.4629 11.6442 12.492 11.5084 12.5502 11.3799L16.0175 3.81454C16.1751 3.47023 16.5218 3.24958 16.9001 3.24958H26.8267C27.3601 3.24958 27.7941 3.68118 27.7966 4.21462L27.8548 14.4274C27.8693 14.4904 27.8742 14.5583 27.8742 14.6262C27.879 15.1621 27.445 15.5985 26.9091 15.5985L26.9095 15.5989ZM14.4031 13.6591H25.9132L25.8647 5.19182H17.5234L14.4029 11.9981L14.4031 13.6591Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M43.5861 15.4536H29.9377C29.4018 15.4536 28.9678 15.0196 28.9678 14.4837V4.44541C28.9678 3.90955 29.4018 3.47552 29.9377 3.47552H38.9456C39.2899 3.47552 39.61 3.65981 39.7846 3.95804L44.36 11.8139C44.4424 11.9545 44.4861 12.1097 44.4909 12.2722L44.5564 14.4568C44.5637 14.7187 44.4642 14.9733 44.2824 15.1624C44.1005 15.3515 43.8484 15.4534 43.5865 15.4534L43.5861 15.4536ZM30.9072 13.5139H42.5868L42.5577 12.5731L38.3871 5.41057H30.9068L30.9072 13.5139Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.05936 30.2535C5.5235 30.2535 5.08948 29.8195 5.08948 29.2837V19.0442H0.974763C0.438905 19.0442 0.00488281 18.6102 0.00488281 18.0743C0.00488281 17.5385 0.438905 17.1044 0.974763 17.1044H6.05936C6.59521 17.1044 7.02924 17.5385 7.02924 18.0743V29.284C7.02924 29.8198 6.59521 30.2538 6.05936 30.2538V30.2535Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M15.7949 36.0052C11.4595 36.0052 7.93408 32.4796 7.93408 28.1443C7.93408 23.8138 11.4596 20.2884 15.7949 20.2884C20.1255 20.2884 23.6508 23.814 23.6508 28.1443C23.6508 32.4797 20.1253 36.0052 15.7949 36.0052ZM15.7949 22.2282C12.5313 22.2282 9.87378 24.8808 9.87378 28.1444C9.87378 31.4081 12.5288 34.0656 15.7949 34.0656C19.0561 34.0656 21.7112 31.4106 21.7112 28.1444C21.7112 24.8832 19.0561 22.2282 15.7949 22.2282Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M41.4404 36.0052C37.1074 36.0052 33.582 32.4796 33.582 28.1443C33.582 23.8138 37.1076 20.2884 41.4404 20.2884C45.7732 20.2884 49.2987 23.814 49.2987 28.1443C49.2987 32.4797 45.7732 36.0052 41.4404 36.0052ZM41.4404 22.2282C38.1768 22.2282 35.5217 24.8808 35.5217 28.1444C35.5217 31.4081 38.1767 34.0656 41.4404 34.0656C44.704 34.0656 47.3591 31.4106 47.3591 28.1444C47.3591 24.8832 44.7041 22.2282 41.4404 22.2282Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.06174 23.816H0.96988C0.434022 23.816 0 23.382 0 22.8461C0 22.3103 0.434022 21.8763 0.96988 21.8763H6.06174C6.59759 21.8763 7.03162 22.3103 7.03162 22.8461C7.03162 23.382 6.60002 23.816 6.06174 23.816Z",
      fill: color
    }, void 0)]
  }), void 0);
});